// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/swipe-item/index.css
// module id = 186
// module chunks = 1